import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable()
export class AccountViewGuard implements CanDeactivate<ComponentCanDeactivate> {
  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {

    return component.canDeactivate() ?
      true :
      confirm('WARNING: You have unsaved changes under Queue Actions.\r\nChoose ‘OK’ to discard changes and proceed or ‘Cancel’ to stay on page.');
  }
}
